var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlofin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 72,
    viewBox: "0 0 40 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 48,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H-8V72H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.59792 39.7746V51.7009L25.8158 37.2685C30.6529 34.7216 33.6321 30.0155 33.6321 24.9228V21.2265L-1.59792 39.7746Z",
    fill: "#FF8800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2127 40.2149L27.5879 36.332C33.6474 38.5291 35.2 42.9969 35.2 47.9169V48.2178C35.2007 52.1851 35.2013 55.4158 33.9686 58.5406C31.4464 64.9306 24.8261 66.2701 16.761 66.2979H-1.6V51.6995L8.79393 46.2269V59.2994C9.162 59.2906 9.54667 59.2864 9.94449 59.2846C10.4542 59.2829 10.9853 59.285 11.5295 59.2874C13.4121 59.2959 15.455 59.305 17.3141 59.1358C23.6596 58.5575 23.5257 53.2395 23.4428 49.9152C23.4338 49.5639 23.4255 49.2349 23.4255 48.9357V48.7323C23.4276 45.9031 23.4303 41.8704 20.2127 40.2149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79461 14.7304C9.13231 14.7493 9.68136 14.7127 10.3672 14.667C12.9943 14.4917 17.6332 14.1824 20.0904 16.3487C22.4924 18.4699 22.4317 21.6538 22.3923 23.7572C22.3833 24.222 22.3757 24.6341 22.3958 24.9703C22.3958 25.8379 22.306 26.6004 22.1416 27.2738L33.646 21.217C33.646 15.4045 32.5024 7.57993 13.2788 7.57895H-1.6V39.7729L8.79461 34.3007V14.7304Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlofin);
export default __webpack_public_path__ + "static/media/blofin.16ebae5059184255f6bd96622edb8a55.svg";
export { ForwardRef as ReactComponent };